// Guided tour for the Work Transformation Dashboard — copy and order follow
// work-transformation-dashboard-tour-elements.xlsx. Keyed steps spotlight the
// matching ref in DashboardTour; steps without a key are centered greetings.
export const TOUR_MODULE_KEY = "work-transformation-dashboard";

export const TOUR_STEPS = [
  {
    // Welcome — centered greeting
    state: "always",
    title: "Welcome to the Work Transformation Dashboard",
    description:
      "This dashboard brings together all your work-related analysis in one place, providing a unified view of your organization’s work, AI potential impact, value creation opportunities, and the skills shaping your workforce.",
    primaryText: "Start Tour",
    secondaryText: "I'll explore on my own",
  },
  {
    state: "always",
    key: "filterBar",
    title: "Filter by Segment",
    description:
      "Use the filters to explore specific segments of your organization. Filter by Business Unit, Function, or Job Level, and then choose a value to update all the widgets on the page. Select Clear to return to the organization-wide view.",
    placement: "bottom",
  },
  {
    // Spotlights the whole grid. The tour deliberately never opens a widget's
    // side panel — it's a body portal and would fight the Tour mask for z-order.
    state: "always",
    key: "widgets",
    title: "Your Key Metrics",
    description:
      "These four headline widgets provide an overview of AI potential impact within your organization. Select any widget to explore a detailed breakdown by Legal Entity, Business Unit, Function, and Job Level.",
    placement: "top",
  },
  {
    state: "always",
    key: "topSkills",
    title: "Top Organizational Skills",
    description: "Here you can see the skills most frequently required across your roles",
    placement: "bottom",
  },
  {
    state: "always",
    key: "collaboration",
    title: "People+AI Collaboration Potential",
    description:
      "This view shows how work could be distributed between people and AI agents — including the share of work that AI agents could handle and the work that remains with people.",
    placement: "bottom",
  },
  {
    // Users with people_plus_ai:view_comp see the $ figure plus hours/yr.
    state: "viewComp",
    key: "totalPotential",
    title: "Total Potential",
    description:
      "This view highlights the estimated dollar value and hours saved each year through the deployment of the AI agents identified across your roles.",
    placement: "top",
  },
  {
    // Replaces the step above without view_comp — the card shows hours only, so
    // this copy must never mention dollars (dashboardTour.test.js guards it).
    state: "noViewComp",
    key: "totalPotential",
    title: "Total Potential",
    description:
      "This view highlights the estimated hours saved each year through the deployment of the AI agents identified across your roles.",
    placement: "top",
  },
  {
    state: "always",
    key: "roi",
    title: "Return on AI Investments",
    description:
      "Finally, see the overall return on your AI investment. Expand the view to explore the AI agents ranked by their individual return.",
    placement: "top",
  },
  {
    // Finish — centered greeting; primary focuses the filter bar.
    state: "always",
    title: "You're all set!",
    description: "Now you're ready to explore how AI can transform work across your organization.",
    primaryText: "Apply a Filter",
    secondaryText: "Done",
  },
];

// Active steps for the viewer, preserving spec order.
export const getTourSteps = (canViewDollarValue) =>
  TOUR_STEPS.filter(
    (step) => step.state === "always" || step.state === (canViewDollarValue ? "viewComp" : "noViewComp"),
  );
